import React from 'react';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import Seo from '../components/Seo';
import './LegalPage.css';

const TermsPage = () => {
  return (
    <div className="legal-page">
      <Seo
        title="Allgemeine Geschäftsbedingungen | Sportphysiotherapie Oliver Bauer"
        description="AGB und Informationen zum Therapieablauf der Sportphysiotherapie Oliver Bauer für Patient:innen aus Hornstein, Leobersdorf und Wiener Neustadt."
        canonical="/agb"
      />
      <Navigation activeSection="" simple />
      <main className="legal-wrapper">
        <section className="legal-content">
          <h1 className="heading-2">Allgemeine Geschäftsbedingungen</h1>
          <p className="body-large section-subtitle">
            Informationen zu Voraussetzungen, Ablauf, Kosten und Verantwortlichkeiten
          </p>

          <ol className="legal-list">
            <li>
              <h4>1. Was ist vor Behandlungsbeginn zu beachten?</h4>
              <p className="legal-label">1.1 Ärztliche Verordnung</p>
              <p>
                Für physiotherapeutische Behandlungen ist eine gültige ärztliche Verordnung erforderlich (Ausnahme:
                präventive Leistungen bei beschwerdefreien Personen). Die Verordnung enthält Ihre Daten, Diagnose,
                Anzahl der Einheiten und die Therapieform. Bitte informieren Sie mich über Beschwerden oder neue
                Befunde.
              </p>
              <p className="legal-label">1.2 Verrechnung</p>
              <p>
                Die Kosten werden vor Therapiebeginn transparent kommuniziert. Als Wahltherapeut besteht kein Vertrag
                mit Krankenkassen; eine Rückerstattung ist daher nicht möglich. Bei vorhandener Zusatzversicherung kann
                die Honorarnote eingereicht werden.
              </p>
              <p className="legal-label">1.3 Befunde</p>
              <p>
                Bringen Sie bitte zum Ersttermin alle relevanten Befunde mit, um eine fundierte Erstbegutachtung zu
                ermöglichen.
              </p>
            </li>

            <li>
              <h4>2. Ablauf der Therapie</h4>
              <p className="legal-label">2.1 Persönliche Einzelbetreuung</p>
              <p>
                Die Behandlung erfolgt als individuelle Eins-zu-eins-Betreuung. Ziele, Maßnahmen, Termine, Dauer,
                Frequenz, Umfang und Kosten werden gemeinsam festgelegt.
              </p>
              <p className="legal-label">2.2 Ihre Behandlung</p>
              <p>
                Leistungen umfassen individuell abgestimmte Therapie, Beratung, administrative Tätigkeiten,
                Vor-/Nachbereitung, Dokumentation sowie die gesetzliche Aufbewahrung (10 Jahre). Einsicht und Kopien
                sind auf Wunsch möglich.
              </p>
              <p className="legal-label">2.3 Grundsätze</p>
              <p>
                Grundlage sind das MTD-Gesetz, die ärztliche Verordnung und die physiotherapeutische Erstbefundung.
                Informationen unterliegen der Verschwiegenheitspflicht; Austausch mit Ärzt:innen erfolgt nur mit Ihrer
                Zustimmung.
              </p>
              <p className="legal-label">2.4 Dokumentation</p>
              <p>
                Sämtliche Maßnahmen werden dokumentiert und zehn Jahre sicher aufbewahrt. Sie haben das Recht auf
                Einsicht und Kopien gegen Kostenersatz.
              </p>
            </li>

            <li>
              <h4>3. Kosten der Behandlung</h4>
              <p>
                Die Behandlungskosten setzen sich aus Einzelleistung, Zeitaufwand und gegebenenfalls Material zusammen.
                Bezahlt werden kann bar, per Überweisung oder Karte. Bei Zahlungsverzug können Verzugszinsen (4 %) und
                Mahnspesen verrechnet werden.
              </p>
            </li>

            <li>
              <h4>4. Ihr Beitrag zur Therapie</h4>
              <p>
                Eine erfolgreiche Behandlung erfordert ehrliche Angaben zu Beschwerden und aktive Mitarbeit, z. B.
                durch regelmäßiges Üben oder Befolgen von Anweisungen. Bei gefährdetem Behandlungserfolg wird gemeinsam
                nach Lösungen gesucht.
              </p>
            </li>

            <li>
              <h4>5. Terminabsagen</h4>
              <p>
                Termine bitte werktags spätestens 24 Stunden vorher absagen. Nicht rechtzeitig abgesagte Termine werden
                in voller Höhe verrechnet.
              </p>
            </li>

            <li>
              <h4>6. Behandlungsende</h4>
              <p>
                Die Therapie endet nach den verordneten Einheiten oder im gegenseitigen Einvernehmen. Beide Seiten
                können jederzeit beenden, insbesondere wenn der Behandlungserfolg nicht erreichbar scheint oder
                Zahlungsmodalitäten nicht eingehalten werden. Abgerechnet werden nur erbrachte Leistungen (ausgenommen
                versäumte Termine).
              </p>
            </li>
          </ol>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default TermsPage;
